import axios from 'axios';

const fetch = (url, type, Data, succeed, failure) => {
    axios({
        method: type, url: url, data: Data,
        headers: {
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, X-Auth-Token, Origin, Authorization',
            'authorization': (localStorage.getItem("tokenheader") !== null && localStorage.getItem("tokenheader") !== undefined) ? localStorage.getItem("tokenheader") : ""
        }

    }).then(res => {
        succeed(res.data);
    }).catch(err => {
        failure(err);
    });
}

export default fetch;
